// extracted by mini-css-extract-plugin
module.exports = {"pad-whiteboard":"pad-whiteboard___2Q-YL","loading":"loading___2WuHg"};